[
    {
      "icon": "mail-o",
      "buttonText": "inbox.email-us.nav-list.inbox",
      "active": true,
      "show": true,
      "component": "inbox"
    },
    {
      "icon": "Telegram-0",
      "buttonText": "inbox.email-us.nav-list.sent",
      "active": true,
      "show": true,
      "component": "sent"
    },
    {
      "icon": "trash-o",
      "buttonText": "inbox.email-us.nav-list.deleted",
      "active": true,
      "show": true,
      "component": "deleted"
    }
]